import angular from "angular";
import { SelectRecordModalService, vsServiceName } from "./service";
import {
  selectRecordModalComponentOptions,
  vsComponentName,
} from "./component";

export const vsModuleName = "selectRecordModalModule";

angular
  .module(vsModuleName, [])
  .service(vsServiceName, SelectRecordModalService)
  .component(vsComponentName, selectRecordModalComponentOptions);
